// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { getVideoEmbeddedUrl } from "@sc/XDL/Utilities";
import React from "react";

export interface VideoProps {
    src: string;
    controls?: boolean;
    extension?: string;
}

type Props = VideoProps;

const Video: React.FC<Props> = ({ src, controls, extension = "mp4" }) => {
    if (!src) {
        return null;
    }

    const isViemo = src.includes("vimeo");
    const isMP4 = src.includes("mp4");
    const embeddedURL = !isMP4 ? getVideoEmbeddedUrl(src) : "";
    return src.includes("mp4") ? (
        <video width="100%" height="100%" controls={controls}>
            <track kind="captions" src="sampleCaptions.vtt" srcLang="en" />
            <source src={src} type={`video/${extension}`}></source>
        </video>
    ) : (
        createWidgetElement("Video/Video", {
            fields: { videoType: isViemo ? "vimeo" : "youtube", videoURL: src, videoParameters: [] },
        })
    );
};

export default Video;
